// extracted by mini-css-extract-plugin
export default {"extraPadding":"extraPadding-6e52"};